// src/lib/layouts/applyBrandKit.ts
import type { BrandKitLayoutSource, PostLayoutConfig } from './types';

/** Merge precedence: base config < brand kit. (User edits are applied later by the caller.) */
export function applyBrandKit(
  config: PostLayoutConfig,
  bk: BrandKitLayoutSource | null,
): PostLayoutConfig {
  if (!bk) return config;
  switch (config.kind) {
    case 'model_x':
      return {
        ...config,
        avatarUrl: config.avatarUrl ?? bk.avatarUrl,
        handle: bk.handle ?? config.handle,
        displayName: config.displayName && config.displayName !== 'The Clippers'
          ? config.displayName
          : (bk.displayName ?? config.displayName),
      };
    case 'choquei':
      return {
        ...config,
        logoUrl: bk.logoUrl ?? config.logoUrl,
        avatarUrl: bk.avatarUrl ?? config.avatarUrl,
        accentColor: bk.accentColor ?? config.accentColor,
        brandName: bk.displayName ?? config.brandName,
      };
    case 'news_post':
      return {
        ...config,
        logoUrl: bk.logoUrl ?? config.logoUrl,
        avatarUrl: bk.avatarUrl ?? config.avatarUrl,
        accentColor: bk.accentColor ?? config.accentColor,
        brandName: bk.displayName ?? config.brandName,
      };
    case 'breaking_news':
      return {
        ...config,
        logoUrl: bk.logoUrl ?? config.logoUrl,
        channelName: bk.displayName ?? config.channelName,
        accentColor: bk.accentColor ?? config.accentColor,
      };
    case 'newspaper':
      return {
        ...config,
        sourceName: bk.displayName ?? config.sourceName,
        accentColor: bk.accentColor ?? config.accentColor,
      };
    case 'instagram':
      return {
        ...config,
        avatarUrl: bk.avatarUrl ?? config.avatarUrl,
        handle: bk.handle ?? config.handle,
      };
    case 'cortes':
      return {
        ...config,
        handle: bk.handle ?? config.handle,
      };
    case 'fofoca':
      return {
        ...config,
        avatarUrl: bk.avatarUrl ?? config.avatarUrl,
        profileName: bk.displayName ?? config.profileName,
        handle: bk.handle ?? config.handle,
        accentColor: bk.accentColor ?? config.accentColor,
      };
    case 'satisfatorio':
      return {
        ...config,
        titleAccentColor: bk.accentColor ?? config.titleAccentColor,
      };
    case 'triple_split':
      return {
        ...config,
        titleAccentColor: bk.accentColor ?? config.titleAccentColor,
      };
    case 'fact_quote':
      return config;
    default:
      // no brand-kit mapping for this kind yet; a no-op merge is safe
      return config;
  }
}
